var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80908 5L5.80908 7L7.2251 7L11.2505 14.9043L9.92041 17.6641C9.4471 18.6467 10.7184 20 11.8091 20L23.8091 20L23.8091 18L11.8091 18L12.7485 16L21.3091 16C21.8631 16 22.0558 15.4927 22.3091 15L25.7759 8.25781C26.0292 7.76512 25.3631 7 24.8091 7L9.47119 7L8.45361 5L6.80908 5L6.20752 5L5.80908 5ZM11.8091 21C11.2786 21 10.7699 21.2107 10.3949 21.5858C10.0198 21.9609 9.80908 22.4696 9.80908 23C9.80908 23.5304 10.0198 24.0391 10.3949 24.4142C10.7699 24.7893 11.2786 25 11.8091 25C12.3395 25 12.8482 24.7893 13.2233 24.4142C13.5984 24.0391 13.8091 23.5304 13.8091 23C13.8091 22.4696 13.5984 21.9609 13.2233 21.5858C12.8482 21.2107 12.3395 21 11.8091 21ZM21.8091 21C21.2786 21 20.7699 21.2107 20.3949 21.5858C20.0198 21.9609 19.8091 22.4696 19.8091 23C19.8091 23.5304 20.0198 24.0391 20.3949 24.4142C20.7699 24.7893 21.2786 25 21.8091 25C22.3395 25 22.8482 24.7893 23.2233 24.4142C23.5984 24.0391 23.8091 23.5304 23.8091 23C23.8091 22.4696 23.5984 21.9609 23.2233 21.5858C22.8482 21.2107 22.3395 21 21.8091 21Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a126513c3dcf4c9fdabce71ab4dedbc4.svg";
export { ForwardRef as ReactComponent };